<div class="container mt-4">
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-bell mr-2"></i> Thông Báo
    </h1>
  
    <p class="lead mb-4">
      Mô-đun thông báo cho phép bạn quản lý các thông báo cho các sự kiện và cập nhật của thư viện. Bạn có thể thêm, chỉnh sửa và xóa thông báo, cũng như xem các thống kê thông báo thông qua các biểu đồ tương tác.
    </p>
  
    <ul class="nav nav-tabs">
    <!--   <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#Overview">
          <i class="fas fa-chart-bar mr-2"></i> Tổng Quan
        </a>
      </li> -->
      <li class="nav-item active">
        <a class="nav-link" data-toggle="tab" href="#List">
          <i class="fas fa-list mr-2"></i> Danh Sách
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#UserManual">
          <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
        </a>
      </li>
    </ul>
  
    <div class="tab-content">
<!--       <div id="Overview" class="tab-pane fade show active">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <ngx-charts-bar-vertical
                [results]="barChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [gradient]="true"
                [xAxis]="true"
                [yAxis]="true"
                [legend]="true"
                [showXAxisLabel]="true"
                [showYAxisLabel]="true"
                xAxisLabel="Danh Mục"
                yAxisLabel="Số Lượng">
              </ngx-charts-bar-vertical>
            </div>
            <div class="col-md-6">
              <ngx-charts-pie-chart
                [results]="pieChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [legend]="true"
                [explodeSlices]="false"
                [labels]="true">
              </ngx-charts-pie-chart>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <ngx-charts-line-chart
                [results]="lineChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [legend]="true"
                [xAxis]="true"
                [yAxis]="true"
                [autoScale]="true">
              </ngx-charts-line-chart>
            </div>
            <div class="col-md-6">
              <ngx-charts-pie-chart
                [results]="doughnutChartData"
                [view]="[400,300]"
                [scheme]="'cool'"
                [legend]="true"
                [explodeSlices]="false"
                [doughnut]="true"
                [labels]="true">
              </ngx-charts-pie-chart>
            </div>
          </div>
        </div>
      </div> -->
  
      <div id="List" class="tab-pane fade show active">
        <div class="container-fluid">
          <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">
            <i class="fas fa-plus"></i> Thêm Thông Báo
          </button>
  
          <button class="btn btn-outline-info mb-3" (click)="refreshData()">
            <i class="fas fa-sync-alt"></i> Refresh
          </button>
  
          <div class="card mb-4">
            <div class="card-body">
              <div class="table-responsive">
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Search by subject..."
                  (input)="updateFilter($event)"
                />
  
                <ngx-datatable
                  class="bootstrap"
                  [rows]="notices"
                  [columnMode]="'force'"
                  [headerHeight]="50"
                  [footerHeight]="50"
                  [rowHeight]="'auto'"
                  [limit]="10"
                  [loadingIndicator]="loadingIndicator"
                  [reorderable]="reorderable"
                  (select)="onSelect($event)"
                  (activate)="onActivate($event)"
                >
                <ngx-datatable-column name="Notification Method" [prop]="'notificationMethod'">
                  <ng-template ngx-datatable-cell-template let-row="row">
                    <span style="color: red;">{{ row.notificationMethod }}</span> 
                  </ng-template>
                </ngx-datatable-column>
                  <ngx-datatable-column name="Receiver" [prop]="'receiver'"></ngx-datatable-column>
                  <!-- <ngx-datatable-column name="Subject" [prop]="'subject'"></ngx-datatable-column> -->
                  <ngx-datatable-column name="Type" [prop]="'type'"></ngx-datatable-column>
                  <<ngx-datatable-column name="Importance" [prop]="'importance'">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <span style="color: blue;">{{ row.importance }}</span> 
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Actions">
                    <ng-template ngx-datatable-cell-template let-row="row">
                      <button type="button" class="btn btn-outline-primary btn-sm mr-2 dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item"  (click)="openEditDialog(row)">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                        <a class="dropdown-item" (click)="deleteNotice(row.id)">
                            <i class="fas fa-trash"></i> Delete
                        </a>
                        <a class="dropdown-item"  (click)="notifyNotice(row)">
                            <i class="fas fa-bell"></i> Notify Member
                        </a>
                        <!-- <a class="dropdown-item" href="#">
                            <i class="fas fa-exclamation-circle"></i> Set Alerts
                        </a> -->
                        <a class="dropdown-item" disabled>
                            <i class="fas fa-calendar-alt"></i> Schedule Notice
                        </a>
                        <a class="dropdown-item" (click)="setHighPriority(row)">
                            <i class="fas fa-star"></i> Set High Priority
                        </a>
                    </div>
                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div id="UserManual" class="tab-pane custom-tab-pane">
        <!-- User Manual content here -->
        <div>
           <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
            <div  [innerHTML]="markdownContent"></div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal for Notification Information Form -->
  <div class="modal fade" id="notificationFormModal" tabindex="-1" aria-labelledby="notificationFormModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="notificationFormModalLabel">Notification Information Form</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form action="#" method="post">
            <div class="form-group">
              <label for="title">Title</label>
              <input type="text" class="form-control" id="title" value="Library Closure Notice" readonly>
            </div>
            <div class="form-group">
              <label for="content">Content Template</label>
              <textarea class="form-control" id="content" rows="5" readonly>
                Dear [receiverName], please be informed that the library will be closed for maintenance from [startDate] to [endDate]. We apologize for any inconvenience caused.
              </textarea>
            </div>
            <!-- Other form fields omitted for brevity -->
          </form>
        </div>
      </div>
    </div>
  </div>
